export const MAX_SIZE_FILE_IN_BYTES = 10485760; // 10mb;
